import { Injectable } from "@angular/core";
import { AirbrakeService } from "../airbrake/airbrake.service";

@Injectable()
export class TimeDurAgoService {
  private MINUTE = 1000 * 60;

  constructor(private airbrakeService: AirbrakeService) {}

  // Returns the start time of the specific duration which happened from the
  // current time backwards.
  // [start time]----Duration (90, 30 days, etc)----[end time][current time]
  public timeFor(dur: string, lastN: number | string) {
    // Round to the nearest minute. We don't want millisecond precision
    // because it reduces cache hits resulting in duplicate API requests.
    const now = new Date();
    const date = new Date(
      Math.round(now.getTime() / this.MINUTE) * this.MINUTE,
    );

    switch (dur) {
      case "90d/1d":
        date.setDate(date.getDate() - Number(lastN));
        break;
      case "90h/1h":
        date.setHours(date.getHours() - Number(lastN));
        break;
      case "90m/1m":
        date.setMinutes(date.getMinutes() - Number(lastN));
        break;
      default:
        this.airbrakeService.notifier.notify({
          error: "Invalid duration in TimeDurAgoService.timeFor",
          params: { duration: dur, last_n: lastN },
        });
        break;
    }

    return date.toISOString();
  }

  public inMinutes(dur: string, lastN: number | string) {
    const n = Number(lastN);

    switch (dur) {
      case "90d/1d":
        return n * 24 * 60;
      case "90h/1h":
        return n * 60;
      case "90m/1m":
        return n;
      default:
        throw new Error(`unknown duration '${dur}'`);
    }
  }
}
